import React, { useEffect } from 'react';

export default function TaxonomyMetadataPicker({ metadata, setMetadata }) {
    const currentYear = new Date().getFullYear();
    const years = [currentYear - 2, currentYear - 1, currentYear, currentYear + 1, currentYear + 2];

    const generateTargetRoot = (year) => `esg-dirty-taxonomy-${year}`;

    useEffect(() => {
        if (!metadata.reportingYear || !metadata.versionLabel || !metadata.S3CorsValue) {
            const defaultYear = metadata.reportingYear || currentYear;
            setMetadata(prev => ({
                ...prev,
                reportingYear: defaultYear,
                versionLabel: prev.versionLabel || "EFRAG Taxonomy Set 1",
                S3CorsValue: "esg",
                targetBucket: "esg-staging-dirty",
                targetRoot: generateTargetRoot(defaultYear)
            }));
        }
    }, [metadata.reportingYear, metadata.versionLabel, metadata.S3CorsValue, setMetadata, currentYear]); 

    const handleYearChange = (year) => {
        setMetadata(prev => ({ 
            ...prev, 
            reportingYear: year,
            targetRoot: generateTargetRoot(year)
        }));
    };

    return (
        <div className="card shadow-sm border-0 mb-3 bg-white border-start border-4 border-primary">
            <div className="card-body p-3">
                
                {/* 🎯 THE DASHBOARD-STYLE LINK */}
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h6 className="fw-bold text-uppercase extra-small text-muted mb-0">Taxonomy Batch Configuration</h6>
                    <a 
                        href="/registered/site-admin/taxonomy-workflow" 
                        className="btn btn-sm btn-outline-primary fw-bold extra-small text-uppercase"
                    >
                        Go To Workflow &rarr;
                    </a>
                </div>

                <div className="row g-2">
                    <div className="col-md-4">
                        <label className="extra-small fw-bold text-dark text-uppercase">Reporting Year</label>
                        <select 
                            className="form-select form-select-sm mt-1" 
                            value={metadata.reportingYear || currentYear} 
                            onChange={(e) => handleYearChange(e.target.value)}
                        >
                            {years.map(y => <option key={y} value={y}>{y}</option>)}
                        </select>
                    </div>
                    <div className="col-md-8">
                        <label className="extra-small fw-bold text-dark text-uppercase">Version Label</label>
                        <input 
                            type="text" 
                            className="form-control form-control-sm mt-1" 
                            value={metadata.versionLabel || ""} 
                            onChange={(e) => setMetadata(prev => ({ ...prev, versionLabel: e.target.value }))} 
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}